import { render, staticRenderFns } from "./SchoolPopover.vue?vue&type=template&id=015828f8&"
import script from "./SchoolPopover.vue?vue&type=script&lang=js&"
export * from "./SchoolPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports